import Layout from "../layout/Layout";



const AppRoutes = [
    {
        path: "/",
        element: <Layout/>
    }
]

export default AppRoutes;



